import { render, staticRenderFns } from "./NoNotifications.vue?vue&type=template&id=d49245b4&"
import script from "./NoNotifications.vue?vue&type=script&lang=js&"
export * from "./NoNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports